import './index.less';

import { Checkbox, Divider, Grid, Textarea, TextLabel } from '@tonic-one/react';
import { memo } from 'react';

import { FileInfo, FormatContent } from '../../../types/report';
import UploadLogo from '../UploadLogo';
import { useTranslation } from 'react-i18next';

const FormatContainer = (props: {
  formatContent: FormatContent;
  setFormatContent: (value: FormatContent) => void;
  withEditPermission: boolean;
}) => {
  const { t } = useTranslation();
  const { formatContent, setFormatContent, withEditPermission } = props;
  return (
    <div>
      <Grid
        className="formatContainer"
        templateColumns="160px max-content"
        rowGap="3x"
      >
        <TextLabel className="itemLabel">
          {t('reportCommon.labels.coverNote')}:
        </TextLabel>
        <Textarea
          mt="1x"
          width={450}
          maxLength={1024}
          rows={3}
          placeholder={t('reportCommon.placeholders.coverNote')}
          value={formatContent.coverDescription}
          onChange={(e: any) =>
            setFormatContent({
              ...formatContent,
              coverDescription: e.target.value,
            })
          }
        />

        <Grid gridColumn="1/3" style={{ margin: '0px -12px' }}>
          <Divider />
        </Grid>

        <TextLabel className="itemLabel">
          {t('reportCommon.labels.companyName')}:
        </TextLabel>
        <Textarea
          mt="1x"
          width={450}
          maxLength={200}
          rows={1}
          placeholder={t('reportCommon.placeholders.companyName')}
          value={formatContent.companyName}
          onChange={(e: any) =>
            setFormatContent({
              ...formatContent,
              companyName: e.target.value,
            })
          }
        />

        <TextLabel className="itemLabel">
          {t('reportCommon.labels.companyLogo')}:
        </TextLabel>
        <Grid mt="1x">
          <Checkbox
            checked={formatContent.isCompanyLogoDisplay}
            onChange={(e: any) => {
              if (!e.target.checked) {
                setFormatContent({
                  ...formatContent,
                  isCompanyLogoDisplay: e.target.checked,
                  fileInfo: {
                    fileError: '',
                  },
                });
              } else {
                setFormatContent({
                  ...formatContent,
                  isCompanyLogoDisplay: e.target.checked,
                });
              }
            }}
          >
            {t('reportCommon.labels.displayCompanyLogo')}
          </Checkbox>
          {formatContent.isCompanyLogoDisplay && (
            <UploadLogo
              withEditPermission={withEditPermission}
              fileInfo={formatContent.fileInfo}
              setFileInfo={(e: FileInfo) => {
                setFormatContent({
                  ...formatContent,
                  fileInfo: {
                    ...e,
                  },
                });
              }}
            />
          )}
        </Grid>

        <Grid gridColumn="1/3">
          <Divider variant="dashed" />
        </Grid>

        <TextLabel className="itemLabel">
          {t('reportCommon.labels.trendLogo')}:
        </TextLabel>
        <Checkbox
          checked={formatContent.isTrendLogoDisplay}
          onChange={(e: any) => {
            setFormatContent({
              ...formatContent,
              isTrendLogoDisplay: e.target.checked,
            });
          }}
        >
          {t('reportCommon.labels.displayTrendLogo')}
        </Checkbox>

        <Grid gridColumn="1/3">
          <Checkbox
            checked={formatContent.isDefaultSettingSave}
            onChange={(e: any) => {
              setFormatContent({
                ...formatContent,
                isDefaultSettingSave: e.target.checked,
              });
            }}
          >
            {t('reportCommon.labels.saveDefault')}
          </Checkbox>
        </Grid>
      </Grid>
    </div>
  );
};

export default memo(FormatContainer);
